import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { business, images } from "@/data/site";
import { Reveal } from "./motion";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative z-10 bg-[#1C1C1C] py-24 sm:py-32 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-xs tracking-[0.3em] uppercase text-[#FF4500] font-bold mb-4">
              The Name Behind The Work
            </p>
            <h2 className="font-display font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
              Moving Lives.
              <br />
              <span className="text-[#FF4500]">Moving Legacies.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.1} className="mt-8 space-y-5 text-neutral-300 text-base sm:text-lg leading-relaxed max-w-2xl">
            <p>
              Duke Summers Moving was named in honor of{" "}
              <span className="text-white font-semibold">
                Samuel Lee "Duke" Summers
              </span>
              . His name represents more than a company name. It represents a
              standard.
            </p>
            <p>
              When customers trust us with their homes, furniture, businesses,
              and belongings, we understand the responsibility that comes with
              that trust.
            </p>
            <p className="text-neutral-400">
              Our mission is simple: provide dependable moving assistance, treat
              people's belongings with care, communicate clearly, and show up
              prepared to do the job right.
            </p>
          </Reveal>

          <Reveal delay={0.2} className="mt-8 flex flex-wrap gap-3">
            {business.secondaryTaglines.map((t) => (
              <span
                key={t}
                className="text-sm font-semibold text-neutral-200 border-l-2 border-[#FF4500] pl-3"
              >
                {t}
              </span>
            ))}
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative h-[420px] sm:h-[520px] overflow-hidden border border-[#3d3d3d]">
              <motion.img
                style={{ y }}
                src={images.aboutBoxes}
                alt="Furniture wrapped in moving blankets beside packed boxes."
                className="absolute inset-0 h-[130%] w-full object-cover -top-[15%]"
              />
              <div className="absolute bottom-0 inset-x-0 pt-20 pb-6 px-6 bg-gradient-to-t from-[#1C1C1C] via-[#1C1C1C]/85 to-transparent">
                <p className="font-display font-bold text-xl [text-shadow:0_1px_8px_rgba(0,0,0,0.8)]">
                  {business.secondaryTaglines[1]}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
